<template>
  <div class="wg-row" style="height:100%;">
    <!-- PRT MODAL -->
    <wg-modal
      v-if="showPrtModal"
      @closeModal="showPrtModal = false"
    >
      <div slot="body" class="wg-row" style="flex-direction:column;align-items:center;">
        <div class="com-anm22-app-text-xxl">{{ $anm22.strLang(lang, 'Print', 'Stampa') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="flex-wrap:nowrap;justify-content:space-around;">
          <div
            v-for="(printer,index) in printers.filter(p => p.printMode.fis)"
            :key="'printer-fis-ticket-'+index"
            class="display-flex action-btn-with-desc"
          >
            <img
              :src="$anm22.icons.getWorldIcon('printf')"
              class="btn print-button-fis"
              :title="printer.name"
              @click="printTicket(printer.idPrinter);"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-m">{{ printer.name + ' Ticket' }}</div>
          </div>
          <div
            v-for="(printer,index) in printers.filter(p => p.printMode.nfis)"
            :key="'printer-nfis-'+index"
            class="display-flex action-btn-with-desc"
          >
            <img
              :src="$anm22.icons.getWorldIcon('print')"
              class="btn print-button-nfis"
              :title="printer.name"
              @click="print(printer.idPrinter, 'nfis');showPrtModal = false;"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-m">{{ printer.name }}</div>
          </div>
          <div v-if="license.config.modules.invoices.enabled" class="display-flex action-btn-with-desc">
            <img
              :src="$anm22.icons.getWorldIcon('printInvoice')"
              class="btn"
              :title="$anm22.strLang(lang, 'Invoice', 'Fattura')"
              @click="printInvoice();showPrtModal = false;"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Invoice', 'Fattura') }}</div>
          </div>
          <div class="display-flex action-btn-with-desc">
            <img
              :src="$anm22.icons.getWorldIcon('cash')"
              class="btn"
              :title="$anm22.strLang(lang, 'Confirm payment without printing', 'Conferma pagamento senza stampa')"
              @click="paySep();showPrtModal = false;"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div
              class="com-anm22-app-text-m"
            >{{ $anm22.strLang(lang, 'Pay without printing', 'Paga senza stampa') }}</div>
          </div>
        </div>
      </div>
    </wg-modal>
    <wg-modal
      v-if="showFisModal"
      @closeModal="showFisModal = false"
    >
      <div slot="body" class="wg-row" style="flex-direction:column;align-items:center;">
        <div class="com-anm22-app-text-xxl">{{ $anm22.strLang(lang, 'Print', 'Stampa') }}</div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row" style="flex-wrap:nowrap;justify-content:space-around;">
          <div
            v-for="(printer,index) in printers.filter(p => p.printMode.fis)"
            :key="'printer-fis-'+index"
            class="display-flex action-btn-with-desc"
          >
            <img
              :src="$anm22.icons.getWorldIcon('printf')"
              class="print-button-fis"
              :title="printer.name"
              @click="print(printer.idPrinter, 'fis');showFisModal = false;"
            />
            <div class="vertical-height-div" style="height:5px;"></div>
            <div class="com-anm22-app-text-m">{{ printer.name }}</div>
          </div>
        </div>
      </div>
    </wg-modal>
    <!-- DIV GESTIONE CONTO SEPARATO -->
    <div class="wg-row no-select" style="flex-wrap:nowrap;align-items:center;justify-content:space-between;padding:10px;">
      <div style="font-size:20px;">
        {{ $anm22.strLang(lang, 'Separate bill', 'Conto separato') }}
      </div>
      <div
          class="com-anm22-app-text-l"
          style="cursor:pointer;border:1px solid #ccc;padding:5px;border-radius:4px;"
          @click="close">
        {{ $anm22.strLang(lang, 'Close', 'Chiudi') }}
      </div>
    </div>
    <div class="com-anm22-app-horizontal-line-light"></div>
    <div class="wg-row" :style="{padding: '10px', height: cartHeight + 'px'}">
      <div class="wg-col wg-xs-12 wg-md-6">
        <div class="no-select com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Items to pay', 'Articoli da pagare') }}</div>
        <div 
            class="wg-row fc-sep-bill-list no-select com-anm22-app-scrolling-panel" 
            :style="{height: listHeight+'px', paddingRight: '10px'}">
          <item-row 
              v-for="(row, index) in toPaySepRows"
              :key="'to-pay-sep-row-'+index" 
              :row="row"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-md-6">
        <div class="no-select com-anm22-app-text-xl">{{ $anm22.strLang(lang, 'Items selected', 'Articoli selezionati') }}</div>
        <div 
            class="wg-row fc-sep-bill-list no-select com-anm22-app-scrolling-panel" 
            :style="{height: listHeight+'px', paddingRight: '10px'}">
          <item-row
            v-for="(row, index) in selectedToPayRows"
            :key="'selected-sep-row-'+index"
            :row="row"
          />
        </div>
      </div>
    </div>
    <div class="com-anm22-app-horizontal-line-light"></div>
    <div class="wg-row" style="padding:10px;">
      <div
        v-if="!order.deliveryPayment && order.deliveryPrice > 0"
        class="wg-row no-select"
        style="flex-wrap:nowrap;align-items:center;margin-bottom:4px;"
      >
        <div class="wg-col wg-xs-10">
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Include delivery', 'Includi consegna') }}</div>
        </div>
        <div
          class="wg-col wg-xs-2 display-flex"
          style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;"
        >
          <label
              class="com-anm22-app-pointer fc-delivery-label"
              :style="{ objectFit: 'contain'}"
          >
            <img v-if="includeDelivery" :src="$anm22.icons.getWorldIcon('tick')" style="height:100%;width:100%;">
            <input
                type="checkbox"
                id="delivery-checkbox"
                @change="includeDelivery = !includeDelivery"
                style="display:none;"
                :disabled="!!order.deliveryPayment"
            >
          </label>
        </div>
      </div>
      <div v-if="license.config.modules.tables.enabled" class="wg-row" style="align-items:center;margin-bottom:4px;">
        <div class="wg-col wg-xs-6">
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Covers', 'Coperti') }}</div>
        </div>
        <div
          class="wg-col wg-xs-6 display-flex"
          style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;"
        >
          <div 
              class="com-anm22-app-pointer com-anm22-food-var-button" 
              style="line-height:24px;height:24px;width:60px;margin:0 2px;" 
              @click="covers++">+</div>
          <div 
              class="com-anm22-app-pointer com-anm22-food-var-button" 
              style="line-height:24px;height:24px;width:60px;margin:0 2px;" 
              @click="covers--">-</div>
          <input
            readonly
            type="text"
            style="height:24px;width:60px;font-size:18px;text-align:right;margin-left:2px;padding:2px;"
            v-model="covers"
            @focus="$emit('select-input', {event: $event, callback: '', data: {}})"
          >
          <div class="horizontal-height-div" style="width:10px;"></div>
          <div class="com-anm22-app-text-xxl" style="white-space:nowrap;">{{ '/ ' + coversToPay }}</div>
        </div>
      </div>
      <div class="wg-row" style="align-items:center;margin-bottom:4px;">
        <div class="wg-col wg-xs-6">
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Discount:', 'Sconto applicato') }}</div>
        </div>
        <div
          class="wg-col wg-xs-6 display-flex"
          style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;"
        >
          <input
            readonly
            type="text"
            class="com-anm22-app-align-right"
            style="width:60px;font-size:18px;height:24px;padding:2px;"
            :value="discount.toFixed(2)"
            @change="discount = Number($event.target.value)"
            @focus="$emit('select-input', {event: $event, callback: '', data: {}})"
          >
          <div class="com-anm22-app-text-xl" style="margin-left:16px;">%</div>
        </div>
      </div>
      <div class="wg-row" style="align-items:center;margin-bottom:4px;">
        <div class="wg-col wg-xs-6">
          <div
            class="com-anm22-app-text-xl"
          >{{ $anm22.strLang(lang, 'Total:', 'Totale:') }}</div>
        </div>
        <div
          class="wg-col wg-xs-6 display-flex"
          style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;"
        >
          <input
            readonly
            type="text"
            :class="['com-anm22-app-align-right', toPayTotal < 0 ? 'price-sub-zero' : '']"
            style="width:100px;font-size:18px;height:24px;padding:2px;"
            :value="toPayTotal.toFixed(2)"
            @focus="$emit('select-input', {event: $event, callback: '', data: {}})"
            @change="setCustomtoPayTotal($event.target.value)"
          />
          <div class="com-anm22-app-text-xl" style="margin-left:10px;">EUR</div>
        </div>
        <!-- <div
          class="wg-col wg-xs-6 display-flex"
          style="flex-wrap:nowrap;align-items:center;justify-content:flex-end;"
        >
          <div class="com-anm22-app-text-xl">{{ toPayTotal.toFixed(2) }}</div>
          <div class="com-anm22-app-text-xl" style="margin-left:12px;">EUR</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
import ItemRow from './FastCashItemRow.vue';

export default {
  components: {
    ItemRow
  },
  props: {
    license: Object,
    order: Object,
    elements: Array,
    printers: Array,
    // In SepBill mode i comandi funzione del tastierino vengono gestiti internamente al componente
    accessControl: Object,
    action: String
  },
  data: function() {
    return {
      pin: "",
      // Modali
      showPrtModal: false,
      showFisModal: false,
      //
      includeDelivery: false,
      covers: 0,
      discount: 0,
      /* Array di id */
      selectedElements: []
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    divHeight() {
      return this.windowHeight - (this.windowWidth >= 992 ? 341 : 291);
    },
    cartHeight() {
      return this.divHeight - 122 
          - (this.license.config.modules.tables.enabled ? 27 : 0)
          - (!this.order.deliveryPayed && this.order.deliveryPrice ? 27 : 0);
    },
    listHeight() {
      return this.windowWidth >= 992 ? this.cartHeight - 20 : Math.floor((this.cartHeight - 40) / 2);
    },
    coversToPay() {
      return this.order.covers[0].filter(c => !c).length;
    },
    listTotal() {
      let result = 0;
      //Articoli + variazioni
      this.selectedElements.forEach(id =>  {
        const elem = this.elements.find(e => e.id === id);
        if(-1 !== elem) {
          result += elem.price;
          elem.variations.forEach(v => {
            result += v.price;
          })
        }
      })
      //Coperti
      if(this.covers > 0){
        result += this.covers * this.order.covers[1];
      }
      //Costo di consegna
      if(this.order.deliveryPrice && this.includeDelivery){
        result += this.order.deliveryPrice;
      }
      return this.$anm22.round(result, 2);
    },
    toPayTotal() {
      return this.$anm22.round(this.listTotal - (this.listTotal / 100 * this.discount), 2);
    },
    toPaySepRows() {
      /* Key: seq, val: rows */
      let result = [];
      this.elements
        .filter(e => -1 === this.selectedElements.indexOf(e.id))
        .forEach(e => {
          if(e.weight === "") {
            if(e.variations.length === 0) {
              /* cerco se una riga con questo prodotto è già presente nell'array */
              const found = result.findIndex(row => row.elem.product === e.product);
              /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
              if(-1 !== found) {
                result[found].elem = e;
                result[found].quantity++;
                result[found].price += e.price;
              } else {
                result.push({
                  elem: e,
                  weightEdit: null,
                  priceEdit: false,
                  deletable: false,
                  onclick: this.selectToPay,
                  quantity: 1,
                  weight: null,
                  price: e.price
                });
              }
            } else {
              result.push({
                elem: e,
                weightEdit: null,
                priceEdit: false,
                deletable: false,
                onclick: this.selectToPay,
                quantity: 1,
                weight: null,
                price: e.price
              });
            }
          } else {
            result.push({
              elem: e,
              weightEdit: false,
              priceEdit: false,
              deletable: false,
              onclick: this.selectToPay,
              quantity: 1,
              weight: e.weight,
              price: e.price
            });
          }
        });
      return result;
    },
    selectedToPayRows() {
      /* Key: seq, val: rows */
      let result = [];
      this.elements
        .filter(e => -1 !== this.selectedElements.indexOf(e.id))
        .forEach(e => {
          if(e.weight === "") {
            if(e.variations.length === 0) {
              /* cerco se una riga con questo prodotto è già presente nell'array */
              const found = result.findIndex(row => row.elem.product === e.product);
              /* Se esiste aggiorno la riga altrimenti la creo e la aggiungo */
              if(-1 !== found) {
                result[found].elem = e;
                result[found].quantity++;
                result[found].price += e.price;
              } else {
                result.push({
                  elem: e,
                  weightEdit: null,
                  priceEdit: false,
                  deletable: false,
                  onclick: this.unselectToPay,
                  quantity: 1,
                  weight: null,
                  price: e.price
                });
              }
            } else {
              result.push({
                elem: e,
                weightEdit: null,
                priceEdit: false,
                deletable: false,
                onclick: this.unselectToPay,
                quantity: 1,
                weight: null,
                price: e.price
              });
            }
          } else {
            result.push({
              elem: e,
              weightEdit: false,
              priceEdit: false,
              deletable: false,
              onclick: this.unselectToPay,
              quantity: 1,
              weight: e.weight,
              price: e.price
            });
          }
        });
      return result;
    },
    sepBillData() {
      return {
        elementIds: this.selectedElements,
        elementRows: this.selectedToPayRows,
        listTotal: this.listTotal,
        payedTotal: this.toPayTotal,
        delivery: this.includeDelivery,
        covers: this.covers
      }
    }
  },
  methods: {
    setDiscount(discount) {
      this.checkAuth("orderDiscount", () => {
        this.order.discount = Number(discount);
        if(this.order.discount > 100) {
          this.order.discount = 100;
        } else if(this.order.discount < 0) {
          this.order.discount = 0;
        }
      });
    },
    setCustomtoPayTotal(newTotal) {
      if(newTotal < 0) {
        newTotal = 0;
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Negative price forbidden",
            "Prezzo negativo non consentito"
          ),
          type: "warning"
        });
      }
      this.checkAuth("orderDiscount", () => {
        this.discount = 100 - (newTotal * 100 / this.listTotal);
      });
    },
    selectToPay(elem) {
      this.selectedElements.push(elem.id);
      if(this.toPaySepRows.length === 0 && this.order.deliveryPrice && !this.order.deliveryPayed) {
        this.includeDelivery = true;
      }
    },
    unselectToPay(elem) {
      const index = this.selectedElements.indexOf(elem.id);
      if(-1 !== index){
        this.selectedElements.splice(index, 1);
      }
    },
    paySep() {
      this.$emit('pay-sep', this.sepBillData);
      this.close();
    },
    print(pid, mode) {
      this.$emit('print-sep', {idPrinter: pid, mode: mode, sepBillData: this.sepBillData});
      this.close();
    },
    printTicket(pid) {
      this.$emit('print-sep-ticket', {idPrinter: pid, sepBillData: this.sepBillData});
    },
    printInvoice() {
      this.$emit('print-invoice-sep', this.sepBillData);
      this.close();
    },
    prtButton() {
      this.showPrtModal = true;
    },
    fisButton() {
      if(this.accessControl.payOrder) {
        const fis = this.printers.filter(p => p.printMode.fis);
        if(fis.length > 1) {
          this.showFisModal = true;
        } else {
          this.print(fis[0].idPrinter, 'fis');
        }
      }
    },
    close() {
      this.$anm22.eventBus.$emit('wg-modal-close');
      this.$emit('close');
      this.includeDelivery = false;
      this.discount = 0;
      this.covers = 0;
      this.selectedElements = [];
    },
    checkAuth(req, callback) {
      if (this.permission == "5" && this.pin === "") {
        const requestData = {
          acRequest: req,
          success: pin => {
            this.pin = pin;
            callback();
          },
          error: pin => {
            this.$anm22.eventBus.$emit("world-headbar-show-message", {
              text: this.$anm22.strLang(
                this.lang,
                "User not authorized",
                "Utente non autorizzato"
              ),
              type: "alarm"
            });
          }
        };
        this.$anm22.eventBus.$emit('food-pin-authorization', requestData);
        // this.showPinRequest = true;
      } else {
        callback();
      }
    },
  },
  created: function() {
  },
  watch: {
    covers(newVal, oldVal) {
      if(newVal < 0) {
        this.covers = 0;
      }
      if(newVal > this.coversToPay) {
        this.covers = this.coversToPay;
      }
    },
    action(cmd, old) {
      //switch cmd
      if(cmd === 'fis') {
        this.fisButton();
      } else if(cmd === 'prt') {
        this.prtButton();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.action-btn-with-desc {
  flex-direction: column;
  align-items: center;
  width: 100px;
  text-align: center;
  .btn {
    border-radius: 5px;
    background-color: #eee;
    padding: 10px;
    cursor: pointer;
    height: 80px;
    width: 80px;
    margin: 0 10px;
    &:hover {
      box-shadow: 0 0 0 2px #2196f3;
    }
  }
}
</style>
